import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../store/auth";
import { SCHEMAS } from "./schemas";
import ContentManager from "./ContentManager";
import SettingsPanel from "./SettingsPanel";
import SectionsPanel from "./SectionsPanel";
import MediaPanel from "./MediaPanel";
import SubmissionsPanel from "./SubmissionsPanel";
import CommercePanel from "./CommercePanel";
import ErrorBoundary from "./ErrorBoundary";

const NAV = [
  { key: "settings", label: "Général & Hero" },
  { key: "sections", label: "Sections" },
  { key: "universe", label: "Univers" },
  { key: "experiences", label: "Expériences" },
  { key: "events", label: "Événements" },
  { key: "artists", label: "Artistes" },
  { key: "collaborators", label: "Collaborateurs" },
  { key: "audio_tracks", label: "Sound" },
  { key: "playlists", label: "Playlists" },
  { key: "subscription_plans", label: "Abonnements" },
  { key: "media", label: "Médiathèque" },
  { key: "submissions", label: "Formulaires" },
  { key: "commerce", label: "Billetterie" },
];

export default function AdminDashboard() {
  const [active, setActive] = useState("settings");
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = () => { logout(); nav("/admin/login"); };

  const render = () => {
    if (active === "settings") return <SettingsPanel />;
    if (active === "sections") return <SectionsPanel />;
    if (active === "media") return <MediaPanel />;
    if (active === "submissions") return <SubmissionsPanel />;
    if (active === "commerce") return <CommercePanel />;
    if (SCHEMAS[active]) return <ContentManager col={active} schema={SCHEMAS[active]} />;
    return null;
  };

  return (
    <div className="min-h-screen bg-black flex">
      <aside className="w-60 shrink-0 border-r border-[#292929] min-h-screen sticky top-0 h-screen flex flex-col">
        <div className="px-6 py-6 border-b border-[#292929]">
          <div className="font-display text-xl">EFFERVESCENCE</div>
          <div className="text-[10px] tracking-widest uppercase text-muted-eff mt-1">Dashboard</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4">
          {NAV.map((n) => (
            <button key={n.key} data-testid={`nav-${n.key}`} onClick={() => setActive(n.key)}
              className={`w-full text-left px-6 py-2.5 text-xs tracking-widest uppercase transition-colors duration-200 ${active === n.key ? "text-white bg-[#0a0a0a] border-l border-white" : "text-muted-eff hover:text-white"}`}>
              {n.label}
            </button>
          ))}
        </nav>
        <div className="border-t border-[#292929] p-4 space-y-2">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[10px] tracking-widest uppercase text-muted-eff hover:text-white px-2 py-1">
            <ExternalLink className="w-3.5 h-3.5" /> Voir le site
          </a>
          <button data-testid="admin-logout" onClick={doLogout} className="flex items-center gap-2 text-[10px] tracking-widest uppercase text-muted-eff hover:text-white px-2 py-1">
            <LogOut className="w-3.5 h-3.5" /> Déconnexion
          </button>
          <div className="text-[10px] text-muted-eff px-2 pt-2 truncate">{user?.email}</div>
        </div>
      </aside>
      <main className="flex-1 min-w-0 px-8 md:px-12 py-10 max-w-[1200px]">
        <ErrorBoundary key={active} onHome={() => setActive("settings")}>{render()}</ErrorBoundary>
      </main>
    </div>
  );
}
